/**
 * Copyright (c) Granthika Co., All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 */

import { get, post, ServerResponse } from './api'
import User from '@/model/user'

export default class UserService {

  private path : string = '/user'
  private userToken : string

  constructor(userToken : string) {
    this.userToken = userToken
  }

  /**
   * 
   * @returns 
   */
  public async setup(user : User) : Promise<User> {
    let result = await post<ServerResponse & {user: User}>(this.path + '/setup', user, this.userToken)
    user = result.user
    return new User(user.token, user.name, user.email, user.hghandle)
  }

  public async self(): Promise<object> {
    let result = await get(this.path + '/self', this.userToken)   
//    console.log('user service self', result)
    return result
  }
}